import React from 'react'

import AGBGeneResults from './agb/AGBGeneResults'
import BipExGeneResults from './bipex/BipExGeneResults'
import Epi25GeneResults from './epi25/Epi25GeneResults'
import SCHEMAGeneResults from './schema/SCHEMAGeneResults'
import IBDGeneResults from './ibd/IBDGeneResults'
import GP2GeneResults from './gp2/GP2GeneResults'
import { DatasetId } from './base/Browser'

const geneResultComponents: Partial<Record<DatasetId, React.ComponentType<any>>> = {
  AGB: AGBGeneResults,
  BipEx: BipExGeneResults,
  Epi25: Epi25GeneResults,
  SCHEMA: SCHEMAGeneResults,
  IBD: IBDGeneResults,
  GP2: GP2GeneResults,
}

export default geneResultComponents
